'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const galleryActions = require('../../../gallery/actions/galleryActions.es');
const galleryModalActions = require('../../../gallery/modal/galleryModalActions.es');
const { trackGridPhotoClick, trackGridPhotoGalleryOpen } = require('../../actions/pdpTrackingActions.es');

class GridPhotoElement extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        const { id } = this.props;

        this.context.executeAction(trackGridPhotoClick);
        this.context.executeAction(galleryActions.setPhoto, { id });
        this.context.executeAction(galleryModalActions.showModal);
        this.context.executeAction(trackGridPhotoGalleryOpen);
    }

    render() {
        const { url, thumb, project, firm } = this.props;
        return (
            <div className="pdp-grid-photo" onClick={this.handleClick}>
                <div className="pdp-grid-photo-content">
                    <a href={ url } className="pdp-grid-photo-link">
                        <div className="pdp-grid-photo-image-wrapper">
                            <img src={ thumb } className="pdp-grid-photo-image"/>
                        </div>
                        <div className="pdp-grid-photo-text">
                            <div className="pdp-grid-photo-title">{ project.name }</div>
                            <div className="pdp-grid-photo-subtitle">{ firm.name }</div>
                        </div>
                    </a>
                </div>
            </div>
        );
    }
}

GridPhotoElement.propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string,
    url: PropTypes.string,
    thumb: PropTypes.string,
    project: PropTypes.shape({
        name: PropTypes.string
    }),
    firm: PropTypes.shape({
        name: PropTypes.string
    })
};

GridPhotoElement.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func
};

module.exports = GridPhotoElement;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridPhotoElement.jsx